import { SimpleTimeString } from '@connect-x-app/shared-types';

import { ISO8601_REGEX } from '../../date-time';

export const isSimpleTimeString = (input: unknown): input is SimpleTimeString => ISO8601_REGEX.SIMPLE_TIME.test(input as string);
